import React from "react";

function generate(element: React.ReactElement, length?: number) {
  return Array.from({ length: length ?? 5 }, (_, i) =>
    React.cloneElement(element, {
      key: i,
    })
  );
}
export default generate;
